// Reference: https://www.betterstimulus.com/architecture/application-controller.html
// application_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
}
